<template lang="pug">
.generic-table(:class="{ loading: loading }")
  .loading-indicator
    span
      img(:src="ajaxLoader")
  table.table.table-hover
    thead
      slot(name="thead")
    tbody
      slot
    tfoot
      slot(name="tfoot")
</template>
<script>
export default {
  props: ['loading'],
  data() {
    return {
      ajaxLoader: require('@/assets/images/ajax-loader.gif')
    }
  }
}
</script>
<style lang="scss">
.generic-table {
  .table {
    margin:0;
    border: 1px solid #dddddd;
    th {
      background: #efefef;
    }
  }
  position: relative;
  .loading-indicator {
    position: absolute;
    display: none;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    span {
      background: white;
      padding: 0px 50px;
      border-radius: 4px;
      box-shadow: 1px 1px 2px 0px gray;
      border: solid gray 1px;
    }
    font-size: 24px;
    z-index: 1;
  }
  &.loading {
    table {
      opacity: 0.5;
    }
    .loading-indicator {
      display: flex;
    }
  }
}


</style>


// WEBPACK FOOTER //
// src/components/common/GenericTable.vue